/** @file The mesh the Weights panel shows: the active mesh tool's, else the selection's at setup. */
import type { Doc, Id } from '@pose2d/format/types';
import type { SelectionSlice } from '../../stores/types';
import { meshTarget, type MeshTarget } from '../../tools/editMesh/meshTarget';
import { setupShownAttachment } from '../../tools/editMesh/setupShownAttachment';

/** The published target when it still names a mesh of `doc`; otherwise meshTarget over the default skin at setup. */
export function weightsTarget(doc: Doc, selection: SelectionSlice, published: { slot: Id; attachment: Id } | null): MeshTarget | null {
  const mesh = published === null ? undefined : doc.attachments[published.attachment];
  if (published !== null && mesh?.type === 'mesh' && doc.slots[published.slot] !== undefined) return { ...published, mesh };
  return meshTarget(doc, selection, setupShownAttachment(doc));
}
